import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	headers: {
		Accept: "application/json",
	},
});

const getPostsPayload = (data, key) => ({
	posts: data?.results?.[key] || [],
	count: data?.count || 0,
	next: data?.next || null,
	previous: data?.previous || null,
});

export async function fetchCategories() {
	const res = await api.get("/api/category/list");
	return res?.data?.categories || [];
}

export async function fetchBlogList(page = 1) {
	const query = page > 1 ? `?p=${page}` : "";
	const res = await api.get(`/api/blog/list${query}`);
	return getPostsPayload(res?.data, "posts");
}

export async function fetchBlogListByCategory(slug, page = 1) {
	const safeSlug = encodeURIComponent(slug);
	const query = page > 1 ? `?slug=${safeSlug}&p=${page}` : `?slug=${safeSlug}`;
	const res = await api.get(`/api/blog/by_category${query}`);
	return getPostsPayload(res?.data, "posts");
}

export async function fetchBlogDetail(slug) {
	const safeSlug = encodeURIComponent(slug);
	const res = await api.get(`/api/blog/detail/${safeSlug}`);
	return res?.data?.post || null;
}

export async function fetchSearchBlog(term, page = 1) {
	const safeTerm = encodeURIComponent(term);
	const query = page > 1 ? `?p=${page}&s=${safeTerm}` : `?s=${safeTerm}`;
	const res = await api.get(`/api/blog/search${query}`);
	return getPostsPayload(res?.data, "filtered_posts");
}
